import { getReaderEnvironment } from './readerApi';

const LEGACY_API_BASE_URLS = {
  labs: 'https://api.labs.jeshua.ong',
  // TODO: replace with the production legacy REST API endpoint once it exists.
  prod: 'https://api.jeshua.ong'
};

export const getLegacyApiBaseUrl = () => LEGACY_API_BASE_URLS[getReaderEnvironment()];
